import { mediacoreApi } from '@apis/mediacoreApi'
import { createOneMutation, deleteByIdMutation, getByIdQuery, updateByIdMutation } from '@apis/mediacoreQueries'
import { Guide, TableResponse } from '@types'

const guidesURL = 'core/instructivos'

const guidesApi = mediacoreApi.injectEndpoints({
  endpoints: (builder) => ({
    getGuideById: builder.query<Guide, { id: number }>({
      query: getByIdQuery(guidesURL),
      providesTags: (_result, _error, { id }) => [{ type: 'Guide', id }],
    }),
    getGuidesList: builder.query<TableResponse<Guide>, void>({
      query: () => ({ url: `${guidesURL}/`, method: 'GET', params: { format: 'json', is_active: true } }),
      providesTags: ['Guide'],
    }),
    createGuide: builder.mutation<Guide, { data: Partial<Guide> }>({
      query: createOneMutation(guidesURL),
      invalidatesTags: ['Guide', 'GuideTable'],
    }),
    updateGuide: builder.mutation<Guide, { id: number; data: Partial<Guide> }>({
      query: updateByIdMutation(guidesURL),
      invalidatesTags: ['Guide', 'GuideTable'],
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        try {
          const { data: updated } = await queryFulfilled
          dispatch(
            guidesApi.util.updateQueryData('getGuideById', { id }, (draft) => {
              Object.assign(draft, updated)
            }),
          )
        } catch {}
      },
    }),
    deleteGuide: builder.mutation<void, { id: number }>({
      query: deleteByIdMutation(guidesURL),
      invalidatesTags: ['Guide', 'GuideTable'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetGuideByIdQuery,
  useGetGuidesListQuery,
  useCreateGuideMutation,
  useUpdateGuideMutation,
  useDeleteGuideMutation,
} = guidesApi
